import Swiper, { Pagination } from 'swiper';
import { updateSwiperSlideA11y } from './swiperA11y';

Swiper.use([Pagination]);

export function initOverlaySlider(sliderEl, {
  initialSlide = 0,
  onActiveSlide,
  swiperOptions = {},
} = {}) {
  if (!sliderEl) return null;

  const baseOptions = {
    spaceBetween: 16,
    initialSlide,
    autoHeight: true,
    pagination: { el: '.js-pagination' },
    on: {
      init() {
        updateSwiperSlideA11y(this, { onActiveSlide });
      },
      slideChange() {
        setTimeout(() => {
          updateSwiperSlideA11y(this, { onActiveSlide });
        }, 500);
      },
    },
  };

  const options = {
    ...baseOptions,
    ...swiperOptions,
    pagination: {
      ...baseOptions.pagination,
      ...(swiperOptions.pagination || {}),
    },
    on: {
      ...baseOptions.on,
      ...(swiperOptions.on || {}),
    },
  };

  return new Swiper(sliderEl, options);
}

